export class Menu {

  constuctor() {
    this.$barsBtn = $('.bars');
    this.$menu = $('.main-menu');
    this.$overlay = $('.fixed-overlay');
    this.$parents = $('.parent');
  }

  _checkIfVisible($el) {
    if($el.find('.submenu').is(':visible')) {
      $el.addClass('active');
    } else {
      $el.removeClass('active');
    }
  }

  init() {
    this.constuctor();
    const self = this;

    this.$barsBtn.on('click', function(event) {
      event.preventDefault();
      self.$menu.toggleClass('active');
    });

    this.$overlay.on('click', function() {
      self.$menu.removeClass('active');
    });

    this.$parents.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      const windowWidth = $(window).width();
      if(windowWidth < 1024) {
        $(this).find('.submenu').stop().slideToggle(function() {
          self._checkIfVisible($(this).parents('.parent'));
        });
      } else {
        $(this).toggleClass('active');
      }
    });

    this.$parents.find('.submenu a').on('click', function(event) {
      event.stopPropagation();
    });

    $(document).on('click', function() {
      self.$parents.removeClass('active');
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utilities/src/menu.js